/* eslint-disable no-nested-ternary, @typescript-eslint/consistent-type-definitions, @typescript-eslint/no-unnecessary-condition */

import { CheckRounded, CloseRounded, ErrorOutline } from '@mui/icons-material';
import styled, { css } from 'styled-components';
import { SnackbarProps } from './Snackbar.types';

type SnackbarWrapperProps = Pick<SnackbarProps, 'type'>;
type ContentWrapperProps = Pick<SnackbarProps, 'type'>;

const SnackbarWrapper = styled.div<SnackbarWrapperProps>`
  align-items: center;
  background-color: ${({ theme, type }) => theme.palette[type].main ?? ''};
  border-radius: ${({ theme }) => theme.spacing(0.5)};
  bottom: ${({ theme }) => theme.spacing(4)};
  box-shadow: 0 12px 17px rgba(0, 0, 0, 0.14), 0 5px 22px rgba(0, 0, 0, 0.12),
    0 7px 8px rgba(0, 0, 0, 0.2);
  display: inline-flex;
  left: 50%;
  max-width: 95%;
  padding: ${({ theme }) => theme.spacing(2)};
  position: fixed;
  transform: translate(-50%);
  z-index: 99999;

  @media (min-width: ${({ theme }) => theme.breakpoints.values.sm + 'px'}) {
    max-width: 550px;
  }
`;

const LeftIconWrapper = styled('div')`
  align-items: center;
  display: flex;
`;

const ContrastTextColorCss = css<ContentWrapperProps>`
  ${({ theme, type }) =>
    type === 'warning'
      ? theme.palette.text.primary
      : theme.palette.common.white};
`;

const IconStyle = css<ContentWrapperProps>`
  fill: ${ContrastTextColorCss};
`;
const SuccessIcon = styled(CheckRounded)`
  ${IconStyle}
`;
const ErrorIcon = styled(ErrorOutline)`
  ${IconStyle}
`;
const CloseIcon = styled(CloseRounded)`
  cursor: pointer;
  ${IconStyle}
`;

const ContentWrapper = styled.div<ContentWrapperProps>`
  color: ${ContrastTextColorCss};
  flex: 1;
  font-size: 1rem;
  line-height: 1.5rem;
  margin: ${({ theme }) => theme.spacing(0, 2)};
`;

export {
  SnackbarWrapper,
  LeftIconWrapper,
  SuccessIcon,
  ErrorIcon,
  CloseIcon,
  ContentWrapper,
};

/* eslint-enable no-nested-ternary, @typescript-eslint/consistent-type-definitions, @typescript-eslint/no-unnecessary-condition */
